import brandDefault from '../../../brand.json';
import { buildAppConfig as buildShared, type RuntimeConfig as SharedRuntimeConfig } from '@atsa/shared';

/**
 * Config de runtime del sitio de empresas. La logica (capas brand.json ->
 * /config.js, fallback a VITE_*) vive en `@atsa/shared`; ver ahi la explicacion.
 */

export { deepMerge, hexToRgb, hexToArgb } from '@atsa/shared';

export type Brand = typeof brandDefault;
export type RuntimeConfig = SharedRuntimeConfig<Brand>;

declare global {
  interface Window {
    __APP_CONFIG__?: RuntimeConfig;
  }
}

export function buildAppConfig(runtime: RuntimeConfig | undefined, env: Record<string, string | undefined>) {
  return buildShared(brandDefault, runtime, env);
}

export const appConfig = buildAppConfig(
  typeof window !== 'undefined' ? window.__APP_CONFIG__ : undefined,
  import.meta.env as unknown as Record<string, string | undefined>,
);

export const brand = appConfig.brand;
